var _path, _path2, _path3, _path4, _g, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.874 21.875L27.1247 21.875",
    stroke: "#632B51",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.874 27.125L21.8752 27.125",
    stroke: "#632B51",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62451 8.525C9.62451 7.68492 9.62451 7.26488 9.788 6.94401C9.93181 6.66177 10.1613 6.4323 10.4435 6.28849C10.7644 6.125 11.1844 6.125 12.0245 6.125H22.6296C22.9965 6.125 23.1799 6.125 23.3526 6.16645C23.5056 6.2032 23.6519 6.26381 23.7862 6.34606C23.9375 6.43882 24.0672 6.56855 24.3267 6.82799L31.6703 14.1721C31.9297 14.4315 32.0594 14.5612 32.1522 14.7126C32.2344 14.8468 32.295 14.9931 32.3318 15.1461C32.3732 15.3188 32.3732 15.5022 32.3732 15.8691V33.475C32.3732 34.3151 32.3732 34.7351 32.2097 35.056C32.0659 35.3382 31.8365 35.5677 31.5542 35.7115C31.2333 35.875 30.8133 35.875 29.9732 35.875H12.0245C11.1844 35.875 10.7644 35.875 10.4435 35.7115C10.1613 35.5677 9.93181 35.3382 9.788 35.056C9.62451 34.7351 9.62451 34.3151 9.62451 33.475V8.525Z",
    stroke: "#632B51"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8735 6.125V14.225C21.8735 15.0651 21.8735 15.4851 22.037 15.806C22.1808 16.0882 22.4103 16.3177 22.6925 16.4615C23.0134 16.625 23.4335 16.625 24.2735 16.625H32.3741",
    stroke: "#632B51"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_371_10410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.2994 33.5998C37.2994 36.803 34.7025 39.3998 31.4991 39.3998C28.2956 39.3998 25.6987 36.803 25.6987 33.5998C25.6987 30.3966 28.2956 27.7998 31.4991 27.7998C34.7025 27.7998 37.2994 30.3966 37.2994 33.5998Z",
    fill: "#EFBF7D",
    stroke: "#632B51"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4986 31.0801L31.8522 30.7265L31.4986 30.373L31.1451 30.7265L31.4986 31.0801ZM30.9986 36.1201C30.9986 36.3962 31.2225 36.6201 31.4986 36.6201C31.7748 36.6201 31.9986 36.3962 31.9986 36.1201L30.9986 36.1201ZM34.3726 33.2465L31.8522 30.7265L31.1451 31.4337L33.6655 33.9537L34.3726 33.2465ZM31.1451 30.7265L28.6247 33.2465L29.3317 33.9537L31.8522 31.4337L31.1451 30.7265ZM30.9986 31.0801L30.9986 36.1201L31.9986 36.1201L31.9986 31.0801L30.9986 31.0801Z",
    fill: "#632B51"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_371_10410",
    x: 24.1987,
    y: 27.2998,
    width: 14.6006,
    height: 14.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_371_10410"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_371_10410",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.831f6b1ed0d5846e9f952874766fbacd.svg";
export { ForwardRef as ReactComponent };